<template>
	<div>
		<div v-if="$utils.have('/smsMarketing/privilege/on')" class="page-btns-box">
			<el-button type="primary" icon="el-icon-plus" @click="$refs.add.show()" size="small">开通权限</el-button>
		</div>
		<div class="page-list-box">
			<el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
				<el-table-column prop="userId" label="用户ID"></el-table-column>
				<el-table-column prop="userName" label="用户名称" min-width="150"></el-table-column>
				<el-table-column prop="status" label="短信营销权限状态">
					<template slot-scope="scope">
						{{scope.row.status == 1 ? '已开启' : '已关闭'}}
					</template>
				</el-table-column>
				<el-table-column prop="authTime" label="首次授权时间"></el-table-column>
				<el-table-column prop="authUserName" label="授权人"></el-table-column>
				<el-table-column fixed="right" label="操作" width="100">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="manage(scope.row)">
							{{scope.row.status == 1 ? '关闭权限' : '开启权限'}}
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div v-if="data" class="page-pagination-box">
			<el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
				:current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
				layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
			</el-pagination>
		</div>
		<add ref="add" @onUpdate="getDataList()"></add>
	</div>
</template>

<script>
	import Add from './components/add.vue'
	const defaultParams = {
		pageNo: 1,
	}
	export default {
		components: {
			Add
		},
		data() {
			return {
				data: null,
				dataList: null,
				params: {
					...defaultParams,
					pageNo: parseInt(this.$route.query.pageNo || 1),
					pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
				},
				listLoading: false,

			}
		},
		mounted() {
			this.getDataList();
		},
		methods: {
			//获取列表
			getDataList() {
				this.listLoading = true;
				this.$request({
						url: "/smsMarketing/privilege/list",
						method: "POST",
						data: {
							...this.params
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = result;
							this.dataList = result.result || [];
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			//选择pageSize
			handleSizeChange(e) {
				this.params.pageNo = 1;
				this.params.pageSize = e;
				this.getDataList();
			},
			manage(data) {
				const _msg = data.status == 1 ? '确定要关闭权限吗?' : '确定要开启权限吗？';
				this.$confirm(_msg, '提示', {
					type: 'warning',
					center: true,
					closeOnClickModal: false
				}).then(() => {
					this.listLoading = true;
					this.$request({
							url: '/smsMarketing/privilege/change',
							method: 'POST',
							params: {
								id: data.id,
								status: data.status == 1 ? 0 : 1
							}
						})
						.then(res => {
							const {
								state,
								msg
							} = res.data;
							if (state == 1) {
								this.getDataList();
							} else {
								this.$message.error(msg || '请求失败');
								this.listLoading = false;
							}
						})
						.catch(() => {
							this.$message.error('请求错误');
							this.listLoading = false;
						})
						.finally(() => {
							// this.listLoading = false;
						});
				});
			},
		}
	}
</script>

<style lang="scss" scoped>

</style>